'use strict'

var fromCharCode = require('../constant/from-char-code.js')

function regexCheck(regex) {
  return check

  function check(code) {
    return regex.test(fromCharCode(code))
  }
}

module.exports = regexCheck



//////////////////
// WEBPACK FOOTER
// ./node_modules/micromark/dist/util/regex-check.js
// module id = 168
// module chunks = 0